import { render, staticRenderFns } from "./CreateStudent.vue?vue&type=template&id=26bb44f1&scoped=true&lang=true&"
import script from "./CreateStudent.vue?vue&type=script&lang=js&"
export * from "./CreateStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bb44f1",
  null
  
)

export default component.exports